import { render } from "./InfoBasicasRepeticao.vue?vue&type=template&id=c37a1d64&scoped=true"
import script from "./InfoBasicasRepeticao.vue?vue&type=script&lang=js"
export * from "./InfoBasicasRepeticao.vue?vue&type=script&lang=js"

import "./InfoBasicasRepeticao.vue?vue&type=style&index=0&id=c37a1d64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37a1d64"]])

export default __exports__